import { useState } from "react";
import { SyncDirection } from "../../../../../../common/sesh_types";
import { SyncEntity } from "../../../../../../src/entity/Sync";
import SyncDetails from "./sync_details/sync_details";
import SyncDirectionSelection from "./sync_direction_selection/sync_direction_selection";

export default function SyncSetup(props: {
	onBackClicked?: () => void;
	editSync?: SyncEntity;
}) {
	const [selectedSyncDirection, setSelectedSyncDirection] =
		useState<SyncDirection | null>(
			props.editSync ? props.editSync.sync_direction : null
		);

	const hasSelectedSyncDirection = selectedSyncDirection !== null;

	const content = hasSelectedSyncDirection ? (
		<SyncDetails
			onBackClicked={() => setSelectedSyncDirection(null)}
			selectedSyncDirection={selectedSyncDirection}
			editSync={props.editSync}
		/>
	) : (
		<SyncDirectionSelection
			onSelected={(selectedSyncDirection) => {
				setSelectedSyncDirection(selectedSyncDirection);
			}}
		/>
	);

	return (
		<>
			{content}

			{props.onBackClicked && (
				<a
					href="#"
					className="secondary-link flex gap-2 items-center"
					onClick={() => props.onBackClicked()}
				>
					<i className="fas fa-chevron-left"></i>Back
				</a>
			)}
		</>
	);
}
